// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.br-page {
  padding: 24px;
  max-width: 1100px;
}
.br-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.br-title {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #121212;
}
.br-sub {
  margin: 0;
  color: #64748b;
  font-size: 14px;
  max-width: 620px;
}
.br-tabs {
  display: inline-flex;
  border: 1px solid var(--borders-color, #e3ebf8);
  border-radius: 999px;
  padding: 3px;
  background: #fff;
}
.br-tabs button {
  border: 0;
  background: transparent;
  padding: 6px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
}
.br-tabs button.active {
  background: var(--button-color, #c9194a);
  color: #fff;
}
.br-note {
  background: var(--danger-light, #fff5f8);
  border: 1px solid var(--danger-color-light, #c9194a80);
  color: #7d102d;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 16px;
}
.br-empty {
  background: #fff;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  padding: 40px 16px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}
.br-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.br-card {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  background: #fff;
  border: 1px solid var(--borders-color, #e3ebf8);
  border-radius: 16px;
  padding: 18px 20px;
}
.br-card-closed {
  opacity: 0.7;
}
.br-card-main {
  flex: 1 1 320px;
  min-width: 0;
}
.br-card-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}
.br-service {
  font-weight: 700;
  font-size: 16px;
  color: #121212;
}
.br-chip {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 2px 8px;
  border: 1px solid transparent;
}
.br-chip-new {
  background: var(--danger-light, #fff5f8);
  color: var(--button-color, #c9194a);
  border-color: var(--danger-color-light, #c9194a80);
}
.br-chip-ok {
  background: #ecfdf3;
  color: #027a48;
  border-color: #abefc6;
}
.br-chip-warn {
  background: #fffbeb;
  color: #b45309;
  border-color: #fde68a;
}
.br-chip-won {
  background: var(--button-color, #c9194a);
  color: #fff;
}
.br-chip-muted {
  background: #f1f5f9;
  color: #64748b;
}
.br-timer {
  font-size: 12px;
  font-weight: 600;
  color: var(--button-color, #c9194a);
}
.br-items {
  margin: 0 0 2px;
  font-size: 14px;
  color: #334155;
}
.br-meta {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}
.br-hint {
  margin: 8px 0 0;
  font-size: 13px;
  color: #475569;
}
.br-hint-won {
  color: var(--button-color, #c9194a);
  font-weight: 600;
}
.br-card-side {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
}
.br-prices {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.br-label {
  font-size: 12px;
  color: #64748b;
}
.br-yours {
  color: #b45309;
  font-weight: 600;
}
.br-big {
  font-size: 22px;
  font-weight: 800;
  color: #121212;
}
.br-price {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  white-space: nowrap;
}
.br-strike {
  text-decoration: line-through;
}
.br-dirham {
  height: 0.8em;
  width: auto;
}
.br-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.br-btn {
  border-radius: 10px;
  padding: 9px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.br-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.br-btn-primary {
  background: var(--button-color, #c9194a);
  color: #fff;
}
.br-btn-outline {
  background: #fff;
  color: var(--button-color, #c9194a);
  border-color: var(--button-color, #c9194a);
}
.br-btn-ghost {
  background: #fff;
  color: #64748b;
  border-color: #e2e8f0;
}
.br-waiting {
  font-size: 13px;
  color: #64748b;
}
.br-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1050;
}
.br-modal {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  width: 100%;
  max-width: 440px;
}
.br-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.br-modal-head h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.br-close {
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: #94a3b8;
  cursor: pointer;
}
.br-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}
.br-compare > div {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: center;
}
.br-input {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 8px 12px;
  margin: 4px 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: var(--button-color, #c9194a);
}
.br-input input {
  border: 0;
  outline: none;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  color: inherit;
}
.br-error {
  color: #b42318;
  font-size: 12px;
  margin: 0 0 8px;
}
.br-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}
.br-modal-actions .br-btn {
  justify-content: center;
}
@media (max-width: 640px) {
  .br-page {
    padding: 16px;
  }
  .br-card-side,
  .br-prices {
    align-items: flex-start;
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BidRequests/BidRequests.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,sDAAsD;EACtD,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,kDAAkD;AACpD;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,aAAa;EACf;EACA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF","sourcesContent":[".br-page {\n  padding: 24px;\n  max-width: 1100px;\n}\n.br-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n.br-title {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 4px;\n  color: #121212;\n}\n.br-sub {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n  max-width: 620px;\n}\n.br-tabs {\n  display: inline-flex;\n  border: 1px solid var(--borders-color, #e3ebf8);\n  border-radius: 999px;\n  padding: 3px;\n  background: #fff;\n}\n.br-tabs button {\n  border: 0;\n  background: transparent;\n  padding: 6px 16px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n}\n.br-tabs button.active {\n  background: var(--button-color, #c9194a);\n  color: #fff;\n}\n.br-note {\n  background: var(--danger-light, #fff5f8);\n  border: 1px solid var(--danger-color-light, #c9194a80);\n  color: #7d102d;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n.br-empty {\n  background: #fff;\n  border: 1px dashed #cbd5e1;\n  border-radius: 16px;\n  padding: 40px 16px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n.br-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.br-card {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  justify-content: space-between;\n  background: #fff;\n  border: 1px solid var(--borders-color, #e3ebf8);\n  border-radius: 16px;\n  padding: 18px 20px;\n}\n.br-card-closed {\n  opacity: 0.7;\n}\n.br-card-main {\n  flex: 1 1 320px;\n  min-width: 0;\n}\n.br-card-top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n.br-service {\n  font-weight: 700;\n  font-size: 16px;\n  color: #121212;\n}\n.br-chip {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border-radius: 999px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n}\n.br-chip-new {\n  background: var(--danger-light, #fff5f8);\n  color: var(--button-color, #c9194a);\n  border-color: var(--danger-color-light, #c9194a80);\n}\n.br-chip-ok {\n  background: #ecfdf3;\n  color: #027a48;\n  border-color: #abefc6;\n}\n.br-chip-warn {\n  background: #fffbeb;\n  color: #b45309;\n  border-color: #fde68a;\n}\n.br-chip-won {\n  background: var(--button-color, #c9194a);\n  color: #fff;\n}\n.br-chip-muted {\n  background: #f1f5f9;\n  color: #64748b;\n}\n.br-timer {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--button-color, #c9194a);\n}\n.br-items {\n  margin: 0 0 2px;\n  font-size: 14px;\n  color: #334155;\n}\n.br-meta {\n  margin: 0;\n  font-size: 13px;\n  color: #64748b;\n}\n.br-hint {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #475569;\n}\n.br-hint-won {\n  color: var(--button-color, #c9194a);\n  font-weight: 600;\n}\n.br-card-side {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  justify-content: flex-end;\n}\n.br-prices {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n}\n.br-label {\n  font-size: 12px;\n  color: #64748b;\n}\n.br-yours {\n  color: #b45309;\n  font-weight: 600;\n}\n.br-big {\n  font-size: 22px;\n  font-weight: 800;\n  color: #121212;\n}\n.br-price {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  white-space: nowrap;\n}\n.br-strike {\n  text-decoration: line-through;\n}\n.br-dirham {\n  height: 0.8em;\n  width: auto;\n}\n.br-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n.br-btn {\n  border-radius: 10px;\n  padding: 9px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.br-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n.br-btn-primary {\n  background: var(--button-color, #c9194a);\n  color: #fff;\n}\n.br-btn-outline {\n  background: #fff;\n  color: var(--button-color, #c9194a);\n  border-color: var(--button-color, #c9194a);\n}\n.br-btn-ghost {\n  background: #fff;\n  color: #64748b;\n  border-color: #e2e8f0;\n}\n.br-waiting {\n  font-size: 13px;\n  color: #64748b;\n}\n.br-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 1050;\n}\n.br-modal {\n  background: #fff;\n  border-radius: 16px;\n  padding: 24px;\n  width: 100%;\n  max-width: 440px;\n}\n.br-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.br-modal-head h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n}\n.br-close {\n  border: 0;\n  background: transparent;\n  font-size: 24px;\n  line-height: 1;\n  color: #94a3b8;\n  cursor: pointer;\n}\n.br-compare {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.br-compare > div {\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n  border-radius: 12px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: center;\n}\n.br-input {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  padding: 8px 12px;\n  margin: 4px 0 8px;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--button-color, #c9194a);\n}\n.br-input input {\n  border: 0;\n  outline: none;\n  width: 100%;\n  font-size: 20px;\n  font-weight: 700;\n  color: inherit;\n}\n.br-error {\n  color: #b42318;\n  font-size: 12px;\n  margin: 0 0 8px;\n}\n.br-modal-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n.br-modal-actions .br-btn {\n  justify-content: center;\n}\n@media (max-width: 640px) {\n  .br-page {\n    padding: 16px;\n  }\n  .br-card-side,\n  .br-prices {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
